import React, { useEffect, useState } from "react";
import { Activity, Users, Trophy, Newspaper } from "lucide-react";
import api from "../../lib/api";

export default function AdminDashboard() {
    const [s, setS] = useState({ teams: 0, games: 0, news: 0, live: 0 });
    useEffect(() => {
        Promise.all([
            api.get("/teams").then(r => r.data),
            api.get("/games").then(r => r.data),
            api.get("/news").then(r => r.data),
        ]).then(([t, g, n]) => {
            setS({ teams: t.length, games: g.length, news: n.length, live: g.filter(x => x.status === "live").length });
        });
    }, []);
    const cards = [
        { label: "Équipes", v: s.teams, icon: Trophy, color: "#7FD93C" },
        { label: "Parties", v: s.games, icon: Activity, color: "#4FE0D5" },
        { label: "En direct", v: s.live, icon: Users, color: "#7FD93C" },
        { label: "Nouvelles", v: s.news, icon: Newspaper, color: "#4FE0D5" },
    ];
    return (
        <div data-testid="admin-dashboard">
            <h1 className="font-display text-4xl uppercase tracking-widest mb-2">Tableau de bord</h1>
            <p className="text-white/60 mb-8 text-sm">Vue d'ensemble du tournoi.</p>
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
                {cards.map(c => (
                    <div key={c.label} className="glass-card p-6" style={{ borderLeft: `4px solid ${c.color}` }}>
                        <c.icon className="mb-3" style={{ color: c.color }} />
                        <div className="font-display text-5xl">{c.v}</div>
                        <div className="label-mini mt-1">{c.label}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}
